import style from "./ChartComponent.module.css";
import { Line } from 'react-chartjs-2'; 
import {
    Chart as ChartJs,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Legend,
    LogarithmicScale
} from "chart.js"

ChartJs.register(
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Legend,
    LogarithmicScale
)
export const ChartComponent = (props) => {
    const { vb, fusionCrossSections } = props
    let labelsArr = [];
    let dataArr = [];
for (let i=0; i<fusionCrossSections?.length; i++){
    labelsArr.push(fusionCrossSections[i].ecm)
    dataArr.push(fusionCrossSections[i].sfu)
}


    const data={
        labels:labelsArr,
        datasets:[
            {
                label:"Fusion Cross Section(mb)",
                data:dataArr,
                backgroundColor:"red",
                borderColor:"grey",
                tension:0,
            }
        ]
    }
    const options = {
        scales:{
            y: {
                title : {
                    
                    display: true,
                    text:"Fusion Cross Section",
                },
                beginAtZero:true,
                type:"logarithmic",
            },
            x: {
                title : {
                    display: true,
                    text:" Ecm (MeV)"
                } 
            },
            
        }
    }
    const chartBackground = {
        id:"chartBackground",
        beforeDatasetsDraw(chart, args, pluginOptions){
            const { ctx, chartArea:{ left, right, width, top, bottom, height } } = chart;
            ctx?.save()

            ctx.strokeStyle = "red";
            ctx.lineWidth= 5;
            ctx.beginPath();
            ctx.moveTo(left, top);
            ctx.lineTo(right, bottom);
            ctx.stroke();
            ctx.restoke();
        }
    }

    return(
        <div className={style.chartContainer}>
            <Line
            data={data}
            options={options}
            // plugins={[chartBackground]}
            >

            </Line>
        </div>
    )
}